export const refundPolicy = `
# DORIDIUM REFUND AND RETURN POLICY

*Last updated: Aug 31st 2025*

Welcome to Doridium (“we,” “us,” or “our”). We are based in Seattle, Washington, USA. We sell and ship original fine art directly to customers. By placing an order with us, you agree to the following refund and return policy and accept our [Terms of Service](terms-of-service). Please read them carefully.  

This Refund & Return Policy forms part of our [Terms of Service](terms-of-service). If there is any conflict between this Policy and the Terms of Service, this Refund & Return Policy will govern.  

**This policy does not limit any statutory rights you may have under applicable consumer laws.**

# 1. How to request a refund or return

To start a refund or return request, please email us at [sales@doridium.com](mailto:sales@doridium.com) and make sure to include your order number.

# 2. If you change you mind

Due to the nature of original fine art, all sales are final and we are under no obligation to offer a refund for an item that you wish to return simply because you changed your mind.

You can start a return request for an undamaged item within 30 days of your purchase.  

Under certain circumstances and at our sole discretion, we may still offer a full or partial refund for such a return.

If offered, the specified refund amount will be issued to your original payment method once we receive the returned item and the condition is verified.

# 3. If your item arrives damaged

If your item arrives damaged, you can open a refund request by emailing us at [sales@doridium.com](mailto:sales@doridium.com) within 14 days of delivery.

Include photos and a description of the damage with the request. You may be asked to return the item as a part of the request.

If accepted, a full refund will be issued to your original payment method once the refund request is fully processed and the item is recieved (if requested).

# 4. Return shipping

All return shipments must be arranged through doridium.com and shipped in their original packaging (including any documentation that may have been included with the order).

# 5. Changes to This Policy

We may update this Refund and return policy from time to time. Changes will be posted here with a new "Last updated" date. Placing an order after publication constitutes acceptance of the updated policy.


`;
